export default __webpack_public_path__ + "static/media/entregue.5b3eb9ae.svg";